import useWidgets from "views/hooks/useWidgets";
import WidgetFormattingSettings from "views/logic/aggregationbuilder/WidgetFormattingSettings";
const isAggregationWidgetConfig = (config) => config && "formattingSettings" in config;
const useColorRules = () => {
  const widgets = useWidgets();
  return widgets.valueSeq().toArray().flatMap((widget) => {
    var _a;
    const { config } = widget;
    const widgetId = widget.id;
    if (isAggregationWidgetConfig(config)) {
      const { chartColors = {} } = (_a = config.formattingSettings) != null ? _a : WidgetFormattingSettings.empty();
      return Object.entries(chartColors).map(
        ([key, value]) => ({
          widgetId,
          name: key,
          color: value
        })
      );
    }
    return [];
  }).filter((entry) => entry !== null);
};
export default useColorRules;
